import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldBody } from 'web-ui-components/lib/molecules/forms';
import { Label, Input } from 'web-ui-components/lib/atoms/forms';
import withValidation from '../../../../containers/withValidation';
import { stripCurrencysIllegalCharacters, fixAmount, isAmountWithinLimit } from '../../../../helpers/fieldHelpers';
import { exchangeRateDecimalPoint } from '../../../../config/ift';

export class PreBookedRate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			preBookedRate: props.preBookedRate,
		};
		this.handleRateChange = this.handleRateChange.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		if (this.state.preBookedRate !== nextProps.preBookedRate) this.setState({ preBookedRate: nextProps.preBookedRate });
	}
	handleOnBlur(event) {
		const exchangeRate = fixAmount(event.target.value, exchangeRateDecimalPoint);
		this.props.onChange(exchangeRate);
	}

	handleRateChange(event) {
		const preBookedRate = stripCurrencysIllegalCharacters(event.target.value, exchangeRateDecimalPoint);
		if (isAmountWithinLimit(preBookedRate)) {
			this.setState({ preBookedRate });
		}
	}
	render() {
		const {
			content: { exchangeRateHeader },
		} = this.props;
		const { preBookedRate } = this.state;
		return (
			<Field>
				<Label className="u-type-size-uist" htmlFor="exchangeRate">
					{exchangeRateHeader}
				</Label>
				<FieldBody>
					<Input
						id="preBookedRate"
						type="text"
						value={preBookedRate}
						onChange={this.handleRateChange}
						onBlur={this.handleOnBlur}
					/>
				</FieldBody>
			</Field>
		);
	}
}

PreBookedRate.propTypes = {
	content: PropTypes.shape({
		exchangeRateHeader: PropTypes.string.isRequired,
	}),
	onChange: PropTypes.func.isRequired,
	preBookedRate: PropTypes.string.isRequired,
};

const validation = withValidation({
	validations: ['required', 'amount'],
	key: 'preBookedRate',
	message: 'Please select one of the options.',
});

export default validation(PreBookedRate);
